import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[localizationWidgetHost]'
})
export class LocalizationWidgetHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
